import { render, staticRenderFns } from "./MaintainerTable.vue?vue&type=template&id=ae47bc92&scoped=true&"
import script from "./MaintainerTable.vue?vue&type=script&lang=js&"
export * from "./MaintainerTable.vue?vue&type=script&lang=js&"
import style0 from "./MaintainerTable.vue?vue&type=style&index=0&id=ae47bc92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae47bc92",
  null
  
)

export default component.exports